export const endpointFetch = async (endpoint, params, message) => {
  return await (fetch(endpoint, {
    cache: 'no-cache',
    mode: 'same-origin',
    credentials: 'same-origin',
    redirect: 'follow',
    ...params,
  }).then(response => response.json())).catch(() => ({
    code: '500',
    message,
  }))
}